import {ButtonProps, IconButton} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

const IconSaveButton: React.FC<ButtonProps> = ({...buttonProps}) => {
  return (
    <IconButton {...buttonProps} color='success'>
      {<SaveIcon />}
    </IconButton>
  );
};

export default IconSaveButton;
